import { ENV_ENV } from '@/config/envVars';

const developOptionsConfig = {
  dev: {
    USE_FAKE_SERVICES_ON_POST_OR_PATCH: false,
    USE_FAKE_RESPONSES_ON_DEFINED_FAKE_ACTIONS: false,
    USE_FAKE_FORMS_AS_DEFAULT_VALUES: true,
  },
  stg: {
    USE_FAKE_SERVICES_ON_POST_OR_PATCH: false,
    USE_FAKE_RESPONSES_ON_DEFINED_FAKE_ACTIONS: false,
    USE_FAKE_FORMS_AS_DEFAULT_VALUES: true,
  },
  prod: {
    USE_FAKE_SERVICES_ON_POST_OR_PATCH: false,
    USE_FAKE_RESPONSES_ON_DEFINED_FAKE_ACTIONS: false,
    USE_FAKE_FORMS_AS_DEFAULT_VALUES: false,
  },
};

export const developOptions = developOptionsConfig[ENV_ENV];
